import { render, staticRenderFns } from "./TruckWeightCapacityPageTable.vue?vue&type=template&id=eeac156e&scoped=true"
import script from "./TruckWeightCapacityPageTable.vue?vue&type=script&lang=js"
export * from "./TruckWeightCapacityPageTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeac156e",
  null
  
)

export default component.exports